import styled from "styled-components";
import { theme } from "../../../config";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background: ${theme.colors.custom.background};
  padding: 57px 83px 15px 83px;
  @media ${theme.breakpoints.mobileAndTablet} {
    padding: 25px 0 15px 16px;
  }
  overflow: auto;
`;

export const HeaderText = styled.h1`
  font-family: Orkney Bold;
  font-size: 34px;
  line-height: 48px;
  margin-bottom: 1em;

  @media ${theme.breakpoints.mobileAndTablet} {
    font-size: 22px;
    line-height: 26px;
  }
`;

export const TableWrapper = styled.div`
  .ant-picker-clear {
    display: none;
  }
`;

export const RowRenderStyle = styled.div`
  word-wrap: break-word;
  word-break: break-word;
`;

export const InputFieldStyled = styled.div`
  .ant-select-selection-item {
    font-size: 14px;
  }
  margin: -10px;
  width: 128px;
`;
